/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::0a4de632442305b3d0e182eea97a1b24>>
 * @codegenCommand yarn build tokens
 */

const themeImportsMap = {
  'light': () => import( /* webpackChunkName: "@atlaskit-internal_atlassian-light" */
  './themes/atlassian-light'),
  'dark': () => import( /* webpackChunkName: "@atlaskit-internal_atlassian-dark" */
  './themes/atlassian-dark'),
  'legacy-light': () => import( /* webpackChunkName: "@atlaskit-internal_atlassian-legacy-light" */
  './themes/atlassian-legacy-light'),
  'legacy-dark': () => import( /* webpackChunkName: "@atlaskit-internal_atlassian-legacy-dark" */
  './themes/atlassian-legacy-dark'),
  'spacing': () => import( /* webpackChunkName: "@atlaskit-internal_atlassian-spacing" */
  './themes/atlassian-spacing'),
  'typography-adg3': () => import( /* webpackChunkName: "@atlaskit-internal_atlassian-typography-adg3" */
  './themes/atlassian-typography-adg3'),
  'shape': () => import( /* webpackChunkName: "@atlaskit-internal_atlassian-shape" */
  './themes/atlassian-shape'),
  'light-new-input-border': () => import( /* webpackChunkName: "@atlaskit-internal_atlassian-light-new-input-border" */
  './themes/atlassian-light-new-input-border'),
  'dark-new-input-border': () => import( /* webpackChunkName: "@atlaskit-internal_atlassian-dark-new-input-border" */
  './themes/atlassian-dark-new-input-border'),
  'light-saturated-palette-changes': () => import( /* webpackChunkName: "@atlaskit-internal_atlassian-light-saturated-palette-changes" */
  './themes/atlassian-light-saturated-palette-changes'),
  'dark-saturated-palette-changes': () => import( /* webpackChunkName: "@atlaskit-internal_atlassian-dark-saturated-palette-changes" */
  './themes/atlassian-dark-saturated-palette-changes'),
  'typography': () => import( /* webpackChunkName: "@atlaskit-internal_atlassian-typography" */
  './themes/atlassian-typography'),
  'typography-minor3': () => import( /* webpackChunkName: "@atlaskit-internal_atlassian-typography-minor3" */
  './themes/atlassian-typography-minor3')
};
export default themeImportsMap;